// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  background: transparent !important;
  background-color: transparent !important;
}
html,
body {
  background: transparent !important;
  background-color: transparent !important;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

#tsparticles {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: -1;
}
`, "",{"version":3,"sources":["webpack://./src/Styles/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,wCAAwC;AAC1C;AACA;;EAEE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,WAAW;AACb","sourcesContent":[".App {\r\n  text-align: center;\r\n  background: transparent !important;\r\n  background-color: transparent !important;\r\n}\r\nhtml,\r\nbody {\r\n  background: transparent !important;\r\n  background-color: transparent !important;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n.App-link {\r\n  color: #61dafb;\r\n}\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n#tsparticles {\r\n  position: fixed;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: -1;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
